import { HttpErrorResponse } from '@angular/common/http';

export class HttpError {
  public tag: any;
  public message!: string;

  constructor(public readonly responseError: HttpErrorResponse | null) {}

  get status() {
    return this.responseError!.status;
  }
}
